import type { IconComponent } from '@twisto/icons'

import { getIconVariantColor } from '../../utils/get-icon-variant-color'
import { useTagContext } from '../../utils/tag.context'

import * as styles from './tag-icon.styles'

type Props = {
  icon: IconComponent
  className?: string
}

export const TagIcon = ({ icon, className }: Props) => {
  const { size, variant } = useTagContext()

  const Icon = icon
  const iconColor = getIconVariantColor(variant)

  return (
    <div
      className={className}
      css={[styles.container, styles.containerSize[size]]}
    >
      <Icon color={iconColor} height="100%" width="100%" />
    </div>
  )
}
